import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell/users")({
  beforeLoad: () => {
    throw redirect({ to: "/solutions", replace: true });
  },
});
